<template>
  <div>
    <v-container
      fluid
      class="main-view"
    >
      <v-row>
        <v-col
          cols="12"
          :class="{ 'pt-8': !fullwidth, 'px-16': !fullwidth, 'pa-0': fullwidth }"
        >
          <slot />
          <base-error-alerts v-if="dense" />
        </v-col>
      </v-row>
    </v-container>
    <slot name="other" />
  </div>
</template>

<script>
export default {
  name: 'BaseViewContainer',

  props: {
    title: {
      type: String,
      default: '',
    },
    fullwidth: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.main-view {
  min-height: 100vh !important;
  min-height: calc(100vh - 48px) !important;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
}
</style>
